import {useContext} from "react";
import blueCheck from "../assets/images/icons/blue-check-icon.svg";
import {MainContext} from "../utils/MainContext";
import bdWhiteLogo from "../assets/images/icons/bd-logo-white.svg";
import {useTranslation} from "react-i18next";

const AlertBox = () => {
    const {alertBoxContent, closeAndClearAlertBox} = useContext(MainContext);
    const {t} = useTranslation();

    return (
        <div className="alertBox" onClick={closeAndClearAlertBox}>
            <div className="mobileBdLogo">
                <img src={bdWhiteLogo} alt="bucard-logo"/>
            </div>
            <h2 className="mobileTitle">
                {alertBoxContent?.content?.title || t("alertBox.thanks")}
            </h2>
            <div className="boxContent">
                {alertBoxContent?.content?.customComponent ? (
                    alertBoxContent?.content?.customComponent
                ) : (
                    <>
                        <div className="icon">
                            <img src={blueCheck} alt="icon"/>
                        </div>
                        <div className="infoArea">
                            <h2 className="title">
                                {alertBoxContent?.content?.title || t("alertBox.thanks")}
                            </h2>
                            <p className="info">
                                {alertBoxContent?.content?.message || t("alertBox.message")}
                            </p>
                            <button
                                className="btn"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closeAndClearAlertBox();
                                }}
                            >
                                {alertBoxContent?.content?.btnValue || t("alertBox.close")}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default AlertBox;
